import { BaseEnum } from './BaseEnum';

export const TODOS = { value: 'TODOS', label: 'Todos' };
export const FALTA_S_JUSTIFICATIVA = {
  value: 'FALTA_S_JUSTIFICATIVA',
  label: 'Falta Sem Justificativa',
};
export const HORAS_EXTRAS = { value: 'HORAS_EXTRAS', label: 'Horas Extras' };
export const FERIAS = { value: 'FERIAS', label: 'Férias' };
export const FERIAS_PONTO = {
  value: 'FERIAS_PONTO',
  label: 'Férias, mas bateu o ponto',
};
export const AFASTADO_PONTO = {
  value: 'AFASTADO_PONTO',
  label: 'Afastado, mas bateu o ponto',
};
export const ATESTADO_PONTO = {
  value: 'ATESTADO_PONTO',
  label: 'Com Atestado, mas bateu o ponto',
};

const OCCURENCY_CHIP_SEARCH_ENUM = [
  TODOS,
  FALTA_S_JUSTIFICATIVA,
  HORAS_EXTRAS,
  FERIAS,
  // FERIAS_PONTO,
  // AFASTADO_PONTO,
  // ATESTADO_PONTO,
];

export default OCCURENCY_CHIP_SEARCH_ENUM;

export const getAbsenceDescriptionByFilter = (type: BaseEnum): string[] => {
  const { value } = type;
  let result: string[] = ['Férias', 'Horas de Atestado', 'Atestado'];
  if (value === FERIAS_PONTO.value) {
    result = ['Férias'];
  } else if (value === ATESTADO_PONTO.value) {
    result = ['Horas de Atestado', 'Atestado'];
  }
  return result;
};
